export enum CommonSVG {
    SEARCH_ICON = 'assets/images/common/search-icon.svg',
    TABLE_VIEW = 'assets/images/common/table-view.svg',
    LIST_VIEW = 'assets/images/common/list-view.svg',
    GRID_VIEW = 'assets/images/common/grid-view.svg',
    IMG_VIEW = 'assets/images/common/img-view.svg',
    DOWNLOAD = 'assets/images/common/download.svg',
    PLUS_ICON = 'assets/images/common/plus-icon.svg'
}

export enum DocumentSVG {
    DOCUMENT = 'assets/images/documents.svg',
    IMG_PREVIEW = 'assets/images/common/documents/img-preview.svg',
    CHECK_ICON ='assets/images/common/documents/check-icon.svg'
}